// The form for the Wi-Fi network (name, password, scan), shared by the Wi-Fi printing setup and the bus pin wizard.
import { WIFI_AUTH } from './device.js';
import { button } from './wizard_dialog.js';

const field = (type, placeholder, id) => Object.assign(document.createElement('input'), { type, placeholder, id, autocomplete: 'off', spellcheck: false });

// Returns { nodes, values() }: values() is {ssid, password}, or null (after saying what is missing) if no name is set.
export function networkForm(getDevice, { ssid: ssid0 = '', password: password0 = '' } = {}) {
  const ssid = field('text', 'Network name', 'wifi-ssid');
  ssid.value = ssid0;
  const password = field('password', 'Password (empty for an open network)', 'wifi-password');
  password.value = password0;
  const list = document.createElement('div');
  list.className = 'wifi-list';
  const msg = document.createElement('small');
  const scan = button('Scan for networks', async () => {
    scan.disabled = true;
    msg.textContent = 'Scanning (about 7 seconds)…';
    list.replaceChildren();
    try {
      const aps = await getDevice().scanWifi();
      msg.textContent = aps.length ? '' : 'No networks found. Try again.';
      for (const ap of aps) {
        list.append(button(`${ap.ssid || '(hidden)'}  ${ap.rssi} dBm · ch ${ap.channel} · ${WIFI_AUTH[ap.auth] ?? '?'}`, () => (ssid.value = ap.ssid), 'outline secondary compact'));
      }
    } catch (e) {
      msg.textContent = `Scan failed: ${e.message}`;
    }
    scan.disabled = false;
  }, 'outline');
  return {
    nodes: [scan, msg, list, ssid, password],
    values() {
      if (!ssid.value) {
        msg.textContent = 'Choose or type the network name.';
        return null;
      }
      return { ssid: ssid.value, password: password.value };
    },
  };
}
